import React from 'react'
import Navbar from '../layout/Navbar';

function Pages() {
  return (
    <>
      <Navbar />
    </>
  );
}

export default Pages